export function getSemanticSortValue({
	q,
	sort,
}: {
	q: string;
	sort?: string | null;
}): string {
	const fallbackSort = 'featured';
	const resolvedSort = sort ?? fallbackSort;
	return q?.length > 0 ? 'tiering' : resolvedSort;
}
